import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import PageHero from "@/components/PageHero";
import BeforeAfter from "@/components/BeforeAfter";
import Testimonials from "@/components/Testimonials";
import NextPageCta from "@/components/NextPageCta";
import { api } from "@/lib/api";
import { BOOK_URL } from "@/lib/booking";

export default function WorkPage() {
  const [gallery, setGallery] = useState([]);
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    api.get("/gallery").then((r) => setGallery(r.data)).catch(() => {});
    api.get("/testimonials").then((r) => setTestimonials(r.data)).catch(() => {});
  }, []);

  return (
    <Layout>
      <PageHero
        eyebrow="Work"
        title="Real properties."
        italic="Real results."
        blurb="A growing portfolio of finished jobs across Warwickshire. Drag the slider on each piece to see the before/after."
      />
      {gallery.length > 0 && <BeforeAfter items={gallery} />}
      {testimonials.length > 0 && <Testimonials items={testimonials} />}
      <NextPageCta href={BOOK_URL} label="Want yours next? →" sub="Book directly on my diary — pick a live slot in seconds." />
    </Layout>
  );
}
